"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userInfoFetched = exports.userConfigFetched = exports.updateUserConfig = exports.updateAccount = exports.submitResetPasswordForm = exports.setUserInfo = exports.setUserConfig = exports.setGoogleQrCode = exports.setAccount = exports.sendResetPasswordEmail = exports.selectAccount = exports.resendVerificationEmail = exports.receiveUserPermissions = exports.receiveBaseNotionalProductInfo = exports.receiveAccount = exports.isFuturesAccount = exports.goToResetPasswordFormStep = exports.goToBaseCurrencyFormStep = exports.getUserPermissions = exports.getUserInfo = exports.getUserConfig = exports.getUserAccounts = exports.getGoogleQrCode = exports.getGoogle2FARecoveryCode = exports.enableYubikey2FA = exports.enable2FA = exports.disable2FA = exports.clearGoogleQrCode = exports.USER_INFO_FETCHED = exports.USER_CONFIG_FETCHED = exports.UPDATE_ACCOUNT = exports.SET_GOOGLE_QRCODE = exports.SET_ACCOUNT = exports.RECEIVE_USER_PERMISSIONS = exports.RECEIVE_KYC = exports.RECEIVE_BASE_NOTIONAL_PRODUCT_INFO = exports.RECEIVE_ACCOUNT = exports.CLEAR_GOOGLE_QRCODE = void 0;
var _apiActions = require("./apiActions");
var _apex = _interopRequireWildcard(require("../../apex"));
var _orderHistoryActions = require("./orderHistoryActions");
var _withdrawActions = require("./withdrawActions");
var _snackbarActions = require("./snackbarActions");
var _modalActions = require("./modalActions");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _kycActions = require("./kycActions");
var _transferActions = require("./transferActions");
var _transferRequestActions = require("./transferRequestActions");
var _affiliateActions = require("../actions/affiliateActions");
var _positionActions = require("./positionActions");
var _depositActions = require("./depositActions");
var _marketStateUpdateActions = require("./marketStateUpdateActions");
var _eotcSettlementActions = require("./eotcSettlementActions");
var _authActions = require("./authActions");
var _loyaltyFeeActions = require("./loyaltyFeeActions");
var _reduxForm = require("redux-form");
var _AccountEventsSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/AccountEventsSubscriptionService"));
var _config = _interopRequireDefault(require("../../config"));
var _userPermissionsContants = require("../../constants/userPermissionsContants");
var _actions = require("../margin/actions");
var _selectors = require("../margin/selectors");
var _actions2 = require("../futures/actions");
var _futuresInstrumentsActions = require("../futures/actions/futuresInstrumentsActions");
var _instrumentActions = require("./instrumentActions");
var _instrumentPositionSelectors = require("../selectors/instrumentPositionSelectors");
var _selectors2 = require("../futures/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var USER_INFO_FETCHED = exports.USER_INFO_FETCHED = 'USER_INFO_FETCHED';
var USER_CONFIG_FETCHED = exports.USER_CONFIG_FETCHED = 'USER_CONFIG_FETCHED';
var RECEIVE_USER_PERMISSIONS = exports.RECEIVE_USER_PERMISSIONS = 'RECEIVE_USER_PERMISSIONS';
var RECEIVE_ACCOUNT = exports.RECEIVE_ACCOUNT = 'RECEIVE_ACCOUNT';
var SET_ACCOUNT = exports.SET_ACCOUNT = 'SET_ACCOUNT';
var RECEIVE_KYC = exports.RECEIVE_KYC = 'RECEIVE_KYC';
var UPDATE_ACCOUNT = exports.UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
var SET_GOOGLE_QRCODE = exports.SET_GOOGLE_QRCODE = 'SET_GOOGLE_QRCODE';
var CLEAR_GOOGLE_QRCODE = exports.CLEAR_GOOGLE_QRCODE = 'CLEAR_GOOGLE_QRCODE';
var RECEIVE_BASE_NOTIONAL_PRODUCT_INFO = exports.RECEIVE_BASE_NOTIONAL_PRODUCT_INFO = 'RECEIVE_BASE_NOTIONAL_PRODUCT_INFO';
var userInfoFetched = exports.userInfoFetched = function userInfoFetched(payload) {
  return {
    type: USER_INFO_FETCHED,
    payload: payload
  };
};
var receiveBaseNotionalProductInfo = exports.receiveBaseNotionalProductInfo = function receiveBaseNotionalProductInfo(payload) {
  return {
    type: RECEIVE_BASE_NOTIONAL_PRODUCT_INFO,
    payload: payload
  };
};
var setUserInfo = exports.setUserInfo = function setUserInfo(payload) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var userInfo;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)('SetUserInfo', {
              UserName: payload.username,
              Email: payload.email
            }));
          case 1:
            userInfo = _context.v;
            if (userInfo.result !== false) {
              dispatch(userInfoFetched(userInfo));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'setUserInfoError',
                text: (0, _errorTextFormatter.formatErrorText)(userInfo),
                type: 'warning'
              }));
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getUserInfo = exports.getUserInfo = function getUserInfo(UserId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var userInfo, OMSsInfo, currentOMSInfo, BaseNotionalProductSymbol, BaseNotionalProductId;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetUserInfo', {
              UserId: UserId
            }))["catch"](function (e) {
              console.error('getUserInfo action error', e);
              return;
            });
          case 1:
            userInfo = _context2.v;
            _context2.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetOMSs', {
              OperatorId: userInfo.OperatorId
            }))["catch"](function (e) {
              console.error('GetOMS action error', e);
              return;
            });
          case 2:
            OMSsInfo = _context2.v;
            currentOMSInfo = OMSsInfo.find(function (OMSInfo) {
              return (OMSInfo.Id || OMSInfo.OMSId) === userInfo.OMSId;
            });
            dispatch(userInfoFetched(userInfo));
            dispatch(getUserPermissions(userInfo.UserId));
            dispatch(getUserConfig(userInfo.UserId, userInfo.UserName));
            dispatch(getUserAccounts(userInfo.OMSId)).then(function (accounts) {
              var selectedAccountId = parseInt(localStorage.getItem('selectedAccountId'), 10);
              if (!accounts.some(function (account) {
                return account.AccountId === selectedAccountId;
              })) {
                var _defaultAccountSelect;
                selectedAccountId = (_defaultAccountSelect = (0, _selectors.defaultAccountSelector)(getState())) === null || _defaultAccountSelect === void 0 ? void 0 : _defaultAccountSelect.AccountId;
              }
              dispatch(selectAccount(selectedAccountId, userInfo.OMSId));
              dispatch((0, _positionActions.getAccountPositions)(selectedAccountId));
            });
            dispatch((0, _affiliateActions.getAffiliate)(userInfo.OMSId, userInfo.UserId));
            dispatch((0, _loyaltyFeeActions.getOperatorLoyaltyFeeConfigs)(userInfo.OMSId));
            if (currentOMSInfo !== null && currentOMSInfo !== void 0 && currentOMSInfo.BaseNotionalProductSymbol && currentOMSInfo !== null && currentOMSInfo !== void 0 && currentOMSInfo.BaseNotionalProductId) {
              BaseNotionalProductSymbol = currentOMSInfo.BaseNotionalProductSymbol, BaseNotionalProductId = currentOMSInfo.BaseNotionalProductId;
              dispatch(receiveBaseNotionalProductInfo({
                BaseNotionalProductSymbol: BaseNotionalProductSymbol,
                BaseNotionalProductId: BaseNotionalProductId
              }));
            }
            if (currentOMSInfo !== null && currentOMSInfo !== void 0 && currentOMSInfo.SystemMarginEnabled) {
              dispatch((0, _actions.initMarginTrading)(currentOMSInfo.SystemMarginEnabled));
            }
            if (userInfo.MarginBorrowerEnabled) {
              dispatch((0, _actions.getMarginInstruments)(userInfo.OMSId));
            }
            if (currentOMSInfo !== null && currentOMSInfo !== void 0 && currentOMSInfo.SystemFuturesEnabled) {
              dispatch((0, _actions2.initFuturesTrading)(currentOMSInfo.SystemFuturesEnabled));
            }

            // Add later. Assumes property returned from GetUserInfo will be FuturesBorrowerEnabled like MarginBorrowerEnabled.
            // if (userInfo.FuturesBorrowerEnabled) {
            //   dispatch(getFuturesInstruments(userInfo.OMSId));
            // }
            if (userInfo.FuturesBorrowerEnabled) {
              // dispatch(getFuturesInstruments());
            }
            return _context2.a(2, userInfo);
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var userConfigFetched = exports.userConfigFetched = function userConfigFetched(payload) {
  return {
    type: USER_CONFIG_FETCHED,
    payload: payload
  };
};
var getUserConfig = exports.getUserConfig = function getUserConfig(UserId, UserName) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch) {
      var userConfig;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetUserConfig', {
              UserId: UserId,
              UserName: UserName
            }))["catch"](function (e) {
              console.error('getUserConfig action error', e);
              return;
            });
          case 1:
            userConfig = _context3.v;
            dispatch(userConfigFetched(userConfig));
            return _context3.a(2, userConfig);
        }
      }, _callee3);
    }));
    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/**
 * Merge `config` arg with existing user config
 */
var updateUserConfig = exports.updateUserConfig = function updateUserConfig(config) {
  return function (dispatch, getState) {
    var mergedConfig = _toConsumableArray(getState().user.userConfig);
    config.forEach(function (current) {
      var index = mergedConfig.findIndex(function (i) {
        return i.Key === current.Key;
      });
      if (index !== -1) {
        mergedConfig[index] = current;
      } else {
        mergedConfig.push(current);
      }
    });
    dispatch(userConfigFetched(mergedConfig));
  };
};
var setUserConfig = exports.setUserConfig = function setUserConfig(UserId, UserName, Config) {
  var getUserConfigAfterSetUserConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var _getState, _getState$user, _getState$user2, userInfo, userConfig;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _getState = getState(), _getState$user = _getState.user, _getState$user2 = _getState$user === void 0 ? {} : _getState$user, userInfo = _getState$user2.userInfo;
            _context4.n = 1;
            return dispatch((0, _apiActions.callAPI)('SetUserConfig', {
              UserId: UserId || userInfo.UserId,
              UserName: UserName || userInfo.UserName,
              Config: Config
            }));
          case 1:
            userConfig = _context4.v;
            if (userConfig.result !== false) {
              if (getUserConfigAfterSetUserConfig) dispatch(getUserConfig(UserId, UserName));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'setUserConfigError',
                text: (0, _errorTextFormatter.formatErrorText)(userConfig),
                type: 'warning'
              }));
            }
            return _context4.a(2, userConfig);
        }
      }, _callee4);
    }));
    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getUserPermissions = exports.getUserPermissions = function getUserPermissions(UserId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch) {
      var permissions, requestPermissions, rolePermissions, roles, permissionRoles, updatedPermissions;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetUserPermissions', {
              UserId: UserId
            }));
          case 1:
            requestPermissions = _context5.v;
            rolePermissions = new Set(_toConsumableArray(requestPermissions));
            if (!(rolePermissions.has(_userPermissionsContants.userPermissions.operator) || rolePermissions.has(_userPermissionsContants.userPermissions.superUser))) {
              _context5.n = 3;
              break;
            }
            _context5.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetUserRoles', {
              UserId: UserId
            }));
          case 2:
            roles = _context5.v;
            permissionRoles = roles.flatMap(function (role) {
              return role.Permissions.map(function (permission) {
                return permission;
              });
            });
            updatedPermissions = new Set([].concat(_toConsumableArray(rolePermissions), _toConsumableArray(permissionRoles)));
            permissions = _toConsumableArray(new Set(updatedPermissions));
            _context5.n = 4;
            break;
          case 3:
            permissions = requestPermissions;
          case 4:
            dispatch(receiveUserPermissions(permissions));
          case 5:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return function (_x7) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var receiveUserPermissions = exports.receiveUserPermissions = function receiveUserPermissions(payload) {
  return {
    type: RECEIVE_USER_PERMISSIONS,
    payload: payload
  };
};
var getUserAccounts = exports.getUserAccounts = function getUserAccounts(OMSId) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch) {
      var userAccountIds, accountInfoArray, _iterator, _step, accountId, accountInfo, _t;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            _context6.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetUserAccounts', {
              OMSId: OMSId
            }));
          case 1:
            userAccountIds = _context6.v;
            accountInfoArray = [];
            _iterator = _createForOfIteratorHelper(userAccountIds);
            _context6.p = 2;
            _iterator.s();
          case 3:
            if ((_step = _iterator.n()).done) {
              _context6.n = 6;
              break;
            }
            accountId = _step.value;
            _context6.n = 4;
            return dispatch((0, _apiActions.callAPI)('GetAccountInfo', {
              AccountId: accountId,
              OMSId: OMSId
            }));
          case 4:
            accountInfo = _context6.v;
            // subscribe to events of every user's account
            _apex["default"].connection.subscribeAccountEvents(accountId, OMSId);
            accountInfoArray.push(accountInfo);
          case 5:
            _context6.n = 3;
            break;
          case 6:
            _context6.n = 8;
            break;
          case 7:
            _context6.p = 7;
            _t = _context6.v;
            _iterator.e(_t);
          case 8:
            _context6.p = 8;
            _iterator.f();
            return _context6.f(8);
          case 9:
            if (accountInfoArray.length > 0) {
              dispatch(receiveAccount(accountInfoArray));
              dispatch((0, _kycActions.subscribeToVerificationLevelUpdateEvents)(accountInfoArray[0]));
            }
            return _context6.a(2, accountInfoArray);
        }
      }, _callee6, null, [[2, 7, 8, 9]]);
    }));
    return function (_x8) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var updateAccount = exports.updateAccount = function updateAccount(loyaltyProduct) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(dispatch, getState) {
      var _getState$user3, selectedAccountId, accounts, OMSId, currentAccount, payload, Amount, ProductId, response, text;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            _getState$user3 = getState().user, selectedAccountId = _getState$user3.selectedAccountId, accounts = _getState$user3.accounts, OMSId = _getState$user3.userInfo.OMSId;
            currentAccount = accounts.find(function (account) {
              return selectedAccountId === account.AccountId;
            });
            payload = _objectSpread(_objectSpread({}, currentAccount), {}, {
              LoyaltyProductId: 0,
              LoyaltyEnabled: false
            });
            if (loyaltyProduct) {
              Amount = loyaltyProduct.Amount, ProductId = loyaltyProduct.ProductId;
              payload.LoyaltyProductId = ProductId;

              // Never enable the loyalty token functionality if the balance is 0.
              if (Amount > 0) {
                payload.LoyaltyEnabled = true;
              }
            }
            _context7.n = 1;
            return dispatch((0, _apiActions.callAPI)('UpdateAccount', payload));
          case 1:
            response = _context7.v;
            if (response.result) {
              text = loyaltyProduct ? 'Fee token successfully set' : 'Fee token successfully unset';
              dispatch((0, _snackbarActions.showSnack)({
                id: 'UpdateAccountSuccess',
                text: text,
                type: 'success'
              }));
              dispatch(getUserAccounts(OMSId));
            } else {
              dispatch((0, _reduxForm.change)('loyaltyTokenForm', 'loyaltyToken', currentAccount.LoyaltyProductId));
              dispatch((0, _snackbarActions.showSnack)({
                id: 'UpdateAccountError',
                text: (0, _errorTextFormatter.formatErrorText)(response),
                type: 'warning'
              }));
            }
          case 2:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return function (_x9, _x0) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var selectAccount = exports.selectAccount = function selectAccount(accountId, OMSId) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(dispatch, getState) {
      var accounts, account, selectedInstrumentId, _selectedInstrumentId;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            accounts = getState().user.accounts;
            account = (accounts || []).find(function (a) {
              return a.AccountId === accountId;
            });
            if (!(!accounts.length || !account)) {
              _context8.n = 1;
              break;
            }
            console.error("No account found with ID ".concat(accountId));
            return _context8.a(2);
          case 1:
            dispatch(setAccount(accountId));

            // Futures instruments endpoint should be called in the very beginning of api call sequence
            if (account.AccountType === 'Futures') {
              selectedInstrumentId = (0, _selectors2.futuresSelectedInstrumentIdSelector)(getState());
              dispatch((0, _futuresInstrumentsActions.getFuturesInstruments)({
                AccountId: accountId,
                selectedInstrumentId: selectedInstrumentId
              }));
            } else {
              _selectedInstrumentId = (0, _instrumentPositionSelectors.selectedInstrumentIdSelector)(getState());
              dispatch((0, _instrumentActions.selectInstrument)(_selectedInstrumentId));
            }

            /**
             * 6 is used as default Limit argument due to length of dashboard Recent Activity feed.
             */
            if (_config["default"].global.privateMarketData) {
              dispatch((0, _orderHistoryActions.getOrders)(accountId, OMSId));
            }
            dispatch((0, _withdrawActions.subscribeToWithdrawalTickets)());
            dispatch((0, _orderHistoryActions.subscribeToOrderHistory)());
            dispatch((0, _orderHistoryActions.subscribeToMarginCancelOrderLiquidationEvents)());
            dispatch((0, _transferActions.getTransfers)(accountId));
            dispatch((0, _transferActions.getIncomingTransfers)(OMSId, accountId));
            dispatch((0, _transferRequestActions.getTransferRequestsReceived)(accountId, OMSId));
            dispatch((0, _transferRequestActions.getTransferRequestsRequested)(accountId, OMSId));
            dispatch((0, _marketStateUpdateActions.initMarketTradeSubscription)());
            dispatch((0, _marketStateUpdateActions.subscribeToMarketTradeUpdated)());
            dispatch((0, _eotcSettlementActions.subscribeToAccountSettlements)());
            _AccountEventsSubscriptionService["default"].subscribe(function (update) {
              return dispatch((0, _kycActions.updateAccount)({
                item: update,
                index: getState().user.accounts.findIndex(function (i) {
                  return i.AccountId === accountId;
                })
              }));
            });
            accounts.forEach(function (a) {
              dispatch((0, _positionActions.getAccountPositions)(a.AccountId));
            });
            dispatch((0, _positionActions.subscribeToAccountPositionEvents)());
            dispatch((0, _withdrawActions.getAccountVerificationLevelConfig)());
            dispatch((0, _depositActions.subscribeToDeposits)());
            localStorage.setItem('selectedAccountId', accountId);
            if (account.AccountType === 'Margin') {
              dispatch((0, _actions.preloadMarginData)(accountId, account.OMSID));
            }
            if (account.AccountType === 'Futures') {
              dispatch((0, _actions2.preloadFuturesData)(accountId, account.OMSID));
              dispatch((0, _actions2.subscribeFuturesOrderHistory)(accountId));
            }
          case 2:
            return _context8.a(2);
        }
      }, _callee8);
    }));
    return function (_x1, _x10) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var receiveAccount = exports.receiveAccount = function receiveAccount(payload) {
  return {
    type: RECEIVE_ACCOUNT,
    payload: payload
  };
};
var setAccount = exports.setAccount = function setAccount(payload) {
  return {
    type: SET_ACCOUNT,
    payload: payload
  };
};
var goToResetPasswordFormStep = exports.goToResetPasswordFormStep = function goToResetPasswordFormStep(step) {
  return function (dispatch) {
    return dispatch((0, _reduxForm.change)('resetPasswordRequest', 'step', step));
  };
};
var goToBaseCurrencyFormStep = exports.goToBaseCurrencyFormStep = function goToBaseCurrencyFormStep(step) {
  return function (dispatch) {
    return dispatch((0, _reduxForm.change)('baseCurrencies', 'step', step));
  };
};
var sendResetPasswordEmail = exports.sendResetPasswordEmail = function sendResetPasswordEmail(UserName) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(dispatch) {
      var response, snackbarPayload;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            _context9.n = 1;
            return dispatch((0, _apiActions.callAPI)('ResetPassword', {
              UserName: UserName
            }));
          case 1:
            response = _context9.v;
            snackbarPayload = response.result ? {
              id: 'sendResetPasswordEmailSuccess',
              // t('Check Your Email For Reset Password Link');
              text: 'Check Your Email For Reset Password Link',
              type: 'success'
            } : {
              id: 'sendResetPasswordEmailError',
              text: (0, _errorTextFormatter.formatErrorText)(response),
              type: 'warning'
            };
            dispatch((0, _snackbarActions.showSnack)(snackbarPayload));
            setTimeout(function () {
              return dispatch((0, _authActions.logout)());
            }, _config["default"].Snackbar.timeout);
          case 2:
            return _context9.a(2);
        }
      }, _callee9);
    }));
    return function (_x11) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var submitResetPasswordForm = exports.submitResetPasswordForm = function submitResetPasswordForm() {
  return function (dispatch, getState) {
    var _getState2 = getState(),
      user = _getState2.user;
    dispatch(sendResetPasswordEmail(user.userInfo.UserName));
  };
};
var setGoogleQrCode = exports.setGoogleQrCode = function setGoogleQrCode(payload) {
  return {
    type: SET_GOOGLE_QRCODE,
    payload: payload
  };
};
var clearGoogleQrCode = exports.clearGoogleQrCode = function clearGoogleQrCode() {
  return {
    type: CLEAR_GOOGLE_QRCODE
  };
};
var getGoogleQrCode = exports.getGoogleQrCode = function getGoogleQrCode() {
  return /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(dispatch) {
      var qrCode;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            _context0.n = 1;
            return _apex["default"].connection.EnableGoogle2FA();
          case 1:
            qrCode = _context0.v;
            dispatch(setGoogleQrCode(qrCode));
          case 2:
            return _context0.a(2);
        }
      }, _callee0);
    }));
    return function (_x12) {
      return _ref0.apply(this, arguments);
    };
  }();
};
var disable2FA = exports.disable2FA = function disable2FA(code) {
  return /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(dispatch, getState) {
      var userInfo, auth, _t2;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            userInfo = getState().user.userInfo;
            _context1.p = 1;
            _context1.n = 2;
            return _apex["default"].connection.Disable2FA();
          case 2:
            _context1.n = 3;
            return dispatch((0, _apiActions.callAPI)('Authenticate2FA', {
              Code: code
            }))["catch"](function (e) {
              return console.log(e);
            });
          case 3:
            auth = _context1.v;
            _context1.n = 5;
            break;
          case 4:
            _context1.p = 4;
            _t2 = _context1.v;
            console.error(_t2);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'DISABLE_2FA_ERROR',
              // t('Code Rejected')
              text: 'Code Rejected',
              type: 'warning'
            }));
          case 5:
            if (auth.Authenticated) {
              dispatch(userInfoFetched(_objectSpread(_objectSpread({}, userInfo), {}, {
                Use2FA: false
              })));
              dispatch((0, _modalActions.closeModal)(_modalActions.MODAL_TYPES.DISABLE_2FA));
              dispatch((0, _snackbarActions.showSnack)({
                id: 'DISABLE_2FA_SUCCESS',
                // t('Two Factor Authenticated is disabled')
                text: 'Two-Factor Authenticated is disabled',
                type: 'success'
              }));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'DISABLE_2FA_ERROR',
                // t('Code Rejected')
                text: 'Code Rejected',
                type: 'warning'
              }));
            }
          case 6:
            return _context1.a(2);
        }
      }, _callee1, null, [[1, 4]]);
    }));
    return function (_x13, _x14) {
      return _ref1.apply(this, arguments);
    };
  }();
};
var enable2FA = exports.enable2FA = function enable2FA(code) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(dispatch, getState) {
      var userInfo, auth;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.n) {
          case 0:
            userInfo = getState().user.userInfo;
            _context10.n = 1;
            return _apex["default"].connection.Authenticate2FA({
              Code: code
            });
          case 1:
            auth = _context10.v;
            if (auth.Authenticated) {
              dispatch((0, _authActions.authSuccess)(auth));
              dispatch(userInfoFetched(_objectSpread(_objectSpread({}, userInfo), {}, {
                Use2FA: true
              })));
              dispatch((0, _modalActions.closeModal)(_modalActions.MODAL_TYPES.ENABLE_2FA));
              dispatch(clearGoogleQrCode());
              dispatch((0, _snackbarActions.showSnack)({
                id: 'ENABLE_2FA_SUCCESS',
                // t('Two Factor Authenticated is enabled')
                text: 'Two-Factor Authenticated is enabled',
                type: 'success'
              }));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'ENABLE_2FA_ERROR',
                // t('Code Rejected')
                text: 'Code Rejected',
                type: 'warning'
              }));
            }
          case 2:
            return _context10.a(2);
        }
      }, _callee10);
    }));
    return function (_x15, _x16) {
      return _ref10.apply(this, arguments);
    };
  }();
};
var enableYubikey2FA = exports.enableYubikey2FA = function enableYubikey2FA(otp) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(dispatch, getState) {
      var userInfo, auth;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            userInfo = getState().user.userInfo;
            _context11.n = 1;
            return dispatch((0, _apiActions.callAPI)('EnableYubico2FA', {
              otp: otp
            }));
          case 1:
            auth = _context11.v;
            if (auth.Enabled2FA) {
              dispatch(userInfoFetched(_objectSpread(_objectSpread({}, userInfo), {}, {
                Use2FA: true
              })));
              dispatch((0, _modalActions.closeModal)(_modalActions.MODAL_TYPES.ENABLE_2FA));
              dispatch(clearGoogleQrCode());
              dispatch((0, _snackbarActions.showSnack)({
                id: 'ENABLE_2FA_SUCCESS',
                // t('Two Factor Authenticated is enabled')
                text: 'Two-Factor Authenticated is enabled',
                type: 'success'
              }));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'ENABLE_2FA_ERROR',
                // t('Code Rejected')
                text: 'Code Rejected',
                type: 'warning'
              }));
            }
          case 2:
            return _context11.a(2);
        }
      }, _callee11);
    }));
    return function (_x17, _x18) {
      return _ref11.apply(this, arguments);
    };
  }();
};
var getGoogle2FARecoveryCode = exports.getGoogle2FARecoveryCode = function getGoogle2FARecoveryCode(code) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(dispatch) {
      var response, recoveryCode;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.n) {
          case 0:
            _context12.n = 1;
            return _apex["default"].connection.RPCPromise('GetGoogle2FARecoveryKey', {
              Code: code
            });
          case 1:
            response = _context12.v;
            recoveryCode = JSON.parse(response.o);
            if (recoveryCode.Authenticated) {
              dispatch((0, _reduxForm.change)('google2FARecoveryKeyModal', 'recoveryKey', recoveryCode.RecoveryKey));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'RECOVERY_ERROR',
                text: recoveryCode.errormsg,
                type: 'warning'
              }));
            }
          case 2:
            return _context12.a(2);
        }
      }, _callee12);
    }));
    return function (_x19) {
      return _ref12.apply(this, arguments);
    };
  }();
};
var resendVerificationEmail = exports.resendVerificationEmail = function resendVerificationEmail(payload) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(dispatch) {
      var Apex, response, snackbarPayload, _t3;
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.p = _context13.n) {
          case 0:
            _context13.p = 0;
            Apex = (0, _apex.getApex)();
            _context13.n = 2;
            break;
          case 1:
            _context13.p = 1;
            _t3 = _context13.v;
            return _context13.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'apexError',
              text: _t3.message,
              type: 'warning'
            })));
          case 2:
            if (Apex.connection.ResendVerificationEmail) {
              _context13.n = 3;
              break;
            }
            return _context13.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'resendVerificationEmailError',
              text: 'Feature Not Available.',
              type: 'warning'
            })));
          case 3:
            _context13.n = 4;
            return Apex.connection.ResendVerificationEmail(payload);
          case 4:
            response = _context13.v;
            snackbarPayload = response.result ? {
              id: 'resendVerificationEmailSuccess',
              // t('Check Your Email For An Account Verification Email');
              text: 'Check Your Email For An Account Verification Email',
              type: 'success'
            } : {
              id: 'resendVerificationEmailError',
              text: (0, _errorTextFormatter.formatErrorText)(response),
              type: 'warning'
            };
            dispatch((0, _snackbarActions.showSnack)(snackbarPayload));
          case 5:
            return _context13.a(2);
        }
      }, _callee13, null, [[0, 1]]);
    }));
    return function (_x20) {
      return _ref13.apply(this, arguments);
    };
  }();
};
var isFuturesAccount = exports.isFuturesAccount = function isFuturesAccount(state) {
  var _state$user = state.user,
    _state$user$accounts = _state$user.accounts,
    accounts = _state$user$accounts === void 0 ? [] : _state$user$accounts,
    selectedAccountId = _state$user.selectedAccountId;
  if (!selectedAccountId) return false;
  var account = accounts.find(function (a) {
    return a.AccountId === selectedAccountId;
  });
  return (account === null || account === void 0 ? void 0 : account.AccountType) === 'Futures';
};